<!-- vue3模版代码 -->
<template>
  <div class="img-panel-wrapper" v-if="props.isShow">
    <div class="img-info-box flex-display flex-justify-start flex-align-center" >
        <div class="preview-box"  v-if="currentImg">
          <div v-if="!isVideoFile(getMediaKey(currentImg))" class="centerP" style="height:100%" :style="restoreNum===3?'left:50%;top:50%':''">
            <div v-if="!isCurrentMediaError" class="drag-title image-preview-stage" style="height:100%">
              <div
                class="image-preview-media"
                :style="{ transform: 'scale(' + scaleNum + ')' }"
              >
                <div class="image-preview-frame">
                  <img
                    ref="imageElement"
                    :src="getMediaKey(currentImg)"
                    alt=""
                    @error="onMediaError(currentImg)"
                    @load="onImageElementLoad"
                  >
                  <canvas
                    v-if="props.type === 'media'"
                    ref="imageAnnotationCanvas"
                    class="image-annotation-canvas"
                  />
                </div>
              </div>
            </div>
            <div v-else class="media-load-error">{{ t('media.imageLoadFailed') }}</div>
          </div>
          <div v-else class="video-wrapper" style="position: relative; width: 100%; height: 100%;">
            <div v-if="isCurrentMediaError" class="media-load-error">{{ t('media.videoLoadFailed') }}</div>
            <video 
              v-else
              ref="videoElement" 
              :src="getMediaKey(currentImg)" 
              style="width:100%;height:100%;" 
              controls
              @timeupdate="handleVideoTimeUpdate"
              @loadedmetadata="handleVideoLoaded"
              @error="onMediaError(currentImg)"
              @loadeddata="onMediaLoad(currentImg)"
            ></video>
            <!-- <canvas 
              ref="canvasElement" 
              class="video-canvas"
              style="position: absolute; top: 0; left: 0; pointer-events: none;"
            ></canvas> -->
          </div>
          <div class="preview-btn" @click="handlePreview">
            <LeftCircleFilled class="ui-icon-action nav-icon" :class="{ 'is-disabled': isPrevDisabled }"/>
          </div>
          <div class="next-btn"  @click="handleNext">
            <RightCircleFilled class="ui-icon-action nav-icon" :class="{ 'is-disabled': isNextDisabled }"/>
          </div>
        </div>
        <div class="img-preview-info-box">
          <div v-if="props.type === 'media'">
            <span class="f16 cf">{{ t('media.detailInfo') }}</span>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">{{ t('media.fileNameLabel') }}</span>
                <span  class="f12 cf ml20">{{props.info.file_name}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">{{ t('media.taskNameLabel') }}</span>
                <span  class="f12 cf ml20">{{props.info.job_name}}</span>
              </div>
              <div v-if="props.showRouteAndPayload" class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">{{ t('media.routeNameLabel') }}</span>
                <span  class="f12 cf ml20">{{props.info.fly_line_name}}</span>
              </div>
              <div v-if="props.showRouteAndPayload" class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">{{ t('media.payloadLabel') }}</span>
                <span  class="f12 cf ml20">{{props.info.payload}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20" >
                <span class="f12 c9 ">{{ t('media.captureTimeLabel') }}</span>
                <span  class="f12 cf ml20">{{props.info.create_time}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9">{{ t('media.downloadLabel') }}</span>
                <a-tooltip v-if="getMediaDownloadBase(currentImg)" :title="t('media.download')">
                  <a
                    class="fz18 ui-icon-action-link ml20"
                    :href="getMediaDownloadHref(currentImg)"
                  >
                    <DownloadOutlined class="ui-icon-action" />
                  </a>
                </a-tooltip>
                <span v-else class="f12 cf ml20">--</span>
              </div>
          </div>
          <div v-if="props.type === 'alarm'">
            <span class="f16 cf">{{ t('media.alarmInfo') }}</span>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">{{ t('media.alarmModelLabel') }}</span>
                <span  class="f12 cf ml20">{{ getAlarmDisplayLabel(currentImg) }}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20" >
                <span class="f12 c9 ">{{ t('media.alarmTimeLabel') }}</span>
                <span  class="f12 cf ml20">{{ currentImg.createTime || currentImg.alarmDate }}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9">{{ t('media.downloadLabel') }}</span>
                <a-tooltip v-if="getMediaDownloadBase(currentImg)" :title="t('media.download')">
                  <a
                    class="fz18 ui-icon-action-link ml20"
                    :href="getMediaDownloadHref(currentImg)"
                    :download="getMediaDownloadFilename(currentImg)"
                  >
                    <DownloadOutlined class="ui-icon-action" />
                  </a>
                </a-tooltip>
                <span v-else class="f12 cf ml20">--</span>
              </div>
          </div>
          <div v-if="props.type === 'point'">
            <span class="f16 cf">{{ t('media.pointFlightDetail') }}</span>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">{{ t('media.nameLabel') }}</span>
                <span  class="f12 cf ml20">{{currentImg.name}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20" >
                <span class="f12 c9 ">{{ t('media.fileSizeLabel') }}</span>
                <span  class="f12 cf ml20">{{currentImg.size}}M</span>
              </div>
              <div class="flex-display flex-justify-between flex-align-center mt20">
                <span class="f12 c9 ">{{ t('media.fileLocationLabel') }}</span>
              </div>
              <div class="map-box mt10" v-if="hasValidLatLng(currentImg)">
                <imageMap :mapInfo="currentImg"/>
              </div>
              <div class="location-empty mt10" v-else>{{ t('media.noLocationInfo') }}</div>
          </div>
          <div class="close-btn" @click="closeImgPreview">
            <CloseOutlined class="ui-icon-action tool-icon"/>
          </div>
        </div>
    </div>
    <div class="img-list-box flex-display flex-justify-center flex-align-end">
      <div class="list-scroll-box flex-display flex-justify-start flex-align-end">
          <div class="ml10 viewer-list" :class="isActiveItem(item, index) ? 'is-active-img' : ''"  v-for="(item,index) in imgSrcList"
              :key="getMediaKey(item) || index" @click="handleImgPreview(index)">
              <div v-if="!isVideoFile(getMediaKey(item))">
                <img v-if="!hasMediaError(item)" v-img-lazy="getMediaKey(item)" class="thumb-media" alt="" @error="onMediaError(item)" @load="onMediaLoad(item)">
                <div v-else class="thumb-media thumb-load-error">{{ t('media.loadFailed') }}</div>
              </div>

              <video v-else-if="!hasMediaError(item)" :src="getMediaKey(item)" class="thumb-media" @error="onMediaError(item)" @loadeddata="onMediaLoad(item)"></video>
              <div v-else class="thumb-media thumb-load-error">{{ t('media.loadFailed') }}</div>
          </div>
      </div>
      <!-- 工具 -->
      <div class="tool-box flex-display flex-justify-center flex-align-center">
        <a-tooltip :title="t('media.zoomIn')">
          <ZoomInOutlined class="mr-20 ui-icon-action tool-icon" :class="{ 'is-disabled': isZoomInDisabled }" @click="scaleImg('enlarge')"/>
        </a-tooltip>
        <a-tooltip :title="t('media.zoomOut')">
          <ZoomOutOutlined class="mr-20 ui-icon-action tool-icon" :class="{ 'is-disabled': isZoomOutDisabled }" @click="scaleImg('narrow')"/>
        </a-tooltip>
        <a-tooltip :title="t('media.restore')">
          <RedoOutlined class="mr-20 ui-icon-action tool-icon" @click="restoreImg()"/>
        </a-tooltip>
        <a-tooltip :title="t('media.markFalseAlarm')" v-if="isSign">
          <HighlightOutlined class="mr-20 ui-icon-action tool-icon" @click="handleMarkImg()"/>
        </a-tooltip>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed, watch, defineComponent, onMounted, ref, nextTick, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { message, Modal } from 'ant-design-vue'
import {
  LeftCircleFilled,
  RightCircleFilled,
  CloseOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  RedoOutlined,
  HighlightOutlined,
  DownloadOutlined
} from '@ant-design/icons-vue'
import imageMap from './imageMap.vue'
import { flagMisreportByAlgorithmAlarm, setAlarmStatus } from '/@/api/alarm'
import { queryImageAnnotations, parseAnnotationString } from '/@/api/annotations'
import {
  rectRelativeToImage,
  relativeToImage,
} from '/@/composables/image-annotator/useCoordinates'
import type { AnnotationItem } from '/@/types/annotation'
import { getAlarmImageUrl } from '/@/utils/joinImgUrl'
import { getAnnotationDisplayLabel } from '/@/utils/annotation-label'
import { useLabelStore } from '/@/composables/image-annotator/useLabelStore'

const { t, locale } = useI18n()
const emit = defineEmits(['onClose', 'on-close'])

// 尝试获取标签库，如果不存在则创建一个空的
let labelStore: ReturnType<typeof useLabelStore> | null = null
try {
  labelStore = useLabelStore()
} catch (error) {
  console.warn('Label store not available in image preview context')
  // 创建一个临时的空标签库，避免后续调用出错
  labelStore = {
    findByEn: () => undefined,
    findByCn: () => undefined,
  } as any
}
const props = withDefaults(defineProps<{
    info?: Record<string, any>,
    list?: Array<object>,
    isShow?: boolean,
    type?: string,
    isSign?: boolean,
    /** 媒体详情是否展示航线名称、拍摄负载（机器人媒体等场景不需要） */
    showRouteAndPayload?: boolean
    }>(), {
  info: () => ({}),
  list: () => [],
  isShow: false,
  type: '',
  isSign: false,
  showRouteAndPayload: true
})
// const imgList = ref(props.list)
const currentImg = ref()
const currentIndex = ref(0)
const imgSrcList = ref([{}])
const scaleNum = ref(1)
const restoreNum = ref(1)
const videoElement = ref<HTMLVideoElement | null>(null)
const canvasElement = ref<HTMLCanvasElement | null>(null)
const imageElement = ref<HTMLImageElement | null>(null)
const imageAnnotationCanvas = ref<HTMLCanvasElement | null>(null)
const currentImageAnnotations = ref<AnnotationItem[]>([])
let annotationRequestId = 0
const isPrevDisabled = computed(() => currentIndex.value <= 0)
const isNextDisabled = computed(() => currentIndex.value >= imgSrcList.value.length - 1)
const isZoomInDisabled = computed(() => scaleNum.value >= 2)
const isZoomOutDisabled = computed(() => scaleNum.value <= 0.8)
const mediaErrorMap = ref<Record<string, boolean>>({})
const isCurrentMediaError = computed(() => hasMediaError(currentImg.value))
// 将 COCO 结果按 image_id 分组后的缓存，避免每次全量遍历
const cocoFramesCache = ref<any[] | null>(null)
let animationFrameId: number | null = null
watch(() => props.isShow, (newValue, oldValue) => {
  if (newValue) {
    imgSrcList.value = props.list
    // currentImg.value = imgSrcList.value[0]
  } else {
    imgSrcList.value = []
  }
})
watch(() => scaleNum.value, () => {
  nextTick(() => {
    syncImageAnnotationCanvas()
    drawImageAnnotations()
  })
})

watch(() => props.info, (newValue, oldValue) => {
  currentImg.value = newValue
  currentImageAnnotations.value = []
  clearImageAnnotationCanvas()
  props.list.forEach((item, index) => {
    switch (props.type) {
      case 'point':
        if (item.name === newValue.name) {
          currentIndex.value = index
        }
        break
      case 'alarm':
        if (item.id === newValue.id) {
          currentIndex.value = index
        }
        break
      default:
        if (item.file_name === newValue.file_name) {
          currentIndex.value = index
        }
    }
    // if (props.type === 'alarm') {
    //   if (item.id === newValue.id) {
    //     currentIndex.value = index
    //   }
    // } else {
    //   if (item.file_name === newValue.file_name) {
    //     currentIndex.value = index
    //   }
    // }
  })
  // 当切换图片/视频时，重置 canvas
  nextTick(() => {
    if (canvasElement.value) {
      clearCanvas()
    }
    if (newValue && newValue.object_keys && newValue.object_keys.indexOf('.mp4') !== -1) {
      // 如果是视频，等待视频加载后设置 canvas 尺寸
      setTimeout(() => {
        handleVideoLoaded()
      }, 100)
    } else if (props.type === 'media' && newValue && !isVideoFile(getMediaKey(newValue))) {
      void loadImageAnnotations(newValue)
    }
  })
})
onMounted(() => {
  // 监听窗口大小变化，调整 canvas 尺寸
  window.addEventListener('resize', onPreviewResize)
})

function onPreviewResize () {
  updateCanvasSize()
  syncImageAnnotationCanvas()
  drawImageAnnotations()
}

function onImageElementLoad () {
  onMediaLoad(currentImg.value)
  syncImageAnnotationCanvas()
  if (props.type === 'media' && currentImg.value) {
    void loadImageAnnotations(currentImg.value)
  } else {
    drawImageAnnotations()
  }
}

async function loadImageAnnotations (item: Record<string, any>) {
  if (props.type !== 'media' || isVideoFile(getMediaKey(item))) {
    currentImageAnnotations.value = []
    clearImageAnnotationCanvas()
    return
  }

  // 使用完整URL而不是相对路径
  const fullPath = getMediaKey(item)
  if (!fullPath) {
    currentImageAnnotations.value = []
    clearImageAnnotationCanvas()
    return
  }

  const requestId = ++annotationRequestId
  try {
    const response = await queryImageAnnotations({ path: fullPath })
    if (requestId !== annotationRequestId) return

    const img = imageElement.value
    const nw = img?.naturalWidth || 0
    const nh = img?.naturalHeight || 0

    if (response?.code === 0 && response.data?.annotation) {
      currentImageAnnotations.value = parseAnnotationString(
        response.data.annotation,
        nw,
        nh
      )
    } else {
      currentImageAnnotations.value = []
    }
    syncImageAnnotationCanvas()
    drawImageAnnotations()
  } catch (error) {
    if (requestId !== annotationRequestId) return
    console.error('Failed to load image annotations:', error)
    currentImageAnnotations.value = []
    clearImageAnnotationCanvas()
  }
}

function syncImageAnnotationCanvas () {
  const img = imageElement.value
  const canvas = imageAnnotationCanvas.value
  if (!img || !canvas || !img.naturalWidth) return

  // 使用布局尺寸（offsetWidth/offsetHeight），避免 getBoundingClientRect
  // 在父级 transform: scale() 下返回视觉尺寸，导致 canvas 被二次缩放而偏移
  const layoutW = img.offsetWidth
  const layoutH = img.offsetHeight
  if (layoutW <= 0 || layoutH <= 0) return

  canvas.width = layoutW
  canvas.height = layoutH
  canvas.style.width = `${layoutW}px`
  canvas.style.height = `${layoutH}px`
}

function drawImageAnnotations () {
  const img = imageElement.value
  const canvas = imageAnnotationCanvas.value
  if (!img || !canvas || !img.naturalWidth) return

  const ctx = canvas.getContext('2d')
  if (!ctx) return

  clearImageAnnotationCanvas()

  const annotations = currentImageAnnotations.value
  if (!annotations.length) return

  const displayW = canvas.width
  const displayH = canvas.height
  const scaleX = displayW / img.naturalWidth
  const scaleY = displayH / img.naturalHeight

  annotations.forEach((ann) => {
    if (ann.shape === 'rectangle' && ann.rect) {
      const pixel = rectRelativeToImage(
        ann.rect,
        img.naturalWidth,
        img.naturalHeight
      )
      const x = pixel.x * scaleX
      const y = pixel.y * scaleY
      const w = pixel.width * scaleX
      const h = pixel.height * scaleY

      ctx.strokeStyle = '#1890ff'
      ctx.lineWidth = 2
      ctx.strokeRect(x, y, w, h)

      const displayLabel = getAnnotationDisplayLabel(ann, locale.value, labelStore || undefined)
      if (displayLabel) {
        ctx.fillStyle = '#1890ff'
        ctx.font = '14px Arial'
        ctx.fillText(displayLabel, x, Math.max(14, y - 5))
      }
      return
    }

    if (ann.shape === 'polygon' && ann.points && ann.points.length >= 3) {
      ctx.beginPath()
      ann.points.forEach((pt, index) => {
        const px = relativeToImage(pt[0], img.naturalWidth) * scaleX
        const py = relativeToImage(pt[1], img.naturalHeight) * scaleY
        if (index === 0) ctx.moveTo(px, py)
        else ctx.lineTo(px, py)
      })
      if (ann.closed !== false) ctx.closePath()
      ctx.strokeStyle = '#1890ff'
      ctx.lineWidth = 2
      ctx.stroke()

      const displayLabel = getAnnotationDisplayLabel(ann, locale.value, labelStore || undefined)
      if (displayLabel && ann.points[0]) {
        const labelX = relativeToImage(ann.points[0][0], img.naturalWidth) * scaleX
        const labelY = relativeToImage(ann.points[0][1], img.naturalHeight) * scaleY
        ctx.fillStyle = '#1890ff'
        ctx.font = '14px Arial'
        ctx.fillText(displayLabel, labelX, Math.max(14, labelY - 5))
      }
    }
  })
}

function clearImageAnnotationCanvas () {
  const canvas = imageAnnotationCanvas.value
  if (!canvas) return
  const ctx = canvas.getContext('2d')
  if (ctx) {
    ctx.clearRect(0, 0, canvas.width, canvas.height)
  }
}
function handleMarkImg () {
  Modal.confirm({
    title: () => t('media.markAsFalseAlarm'),
    zIndex: 10000, // 确保在图片预览组件之上 (预览组件 z-index: 9999)
    okText: t('common.confirm'),
    cancelText: t('common.cancel'),
    onOk () {
      setAlarmStatus({ id: currentImg.value.id, marker_status: 0 }).then(res => {
        if (res.code === 0) {
          message.success(t('media.markSuccess'))
          imgSrcList.value.forEach((el, index) => {
            if (index === currentIndex.value) {
              imgSrcList.value.splice(index, 1)
              if (imgSrcList.value.length > currentIndex.value) {
                currentImg.value = imgSrcList.value[currentIndex.value]
              } else {
                if (imgSrcList.value.length === 0) {
                  emit('onClose', false)
                  return
                }
                currentImg.value = imgSrcList.value[imgSrcList.value.length - 1]
                currentIndex.value = imgSrcList.value.length - 1
              }
              console.log('删除图片后', imgSrcList.value)
            }
          })
        }
      })
    },
    onCancel () {
      console.log('Cancel')
    }
  })
}
function restoreImg () {
  scaleNum.value = 1
  restoreNum.value = 3
}
function scaleImg (type:string) {
  if (type === 'enlarge') {
    if (isZoomInDisabled.value) {
      return
    }
    scaleNum.value += 0.2
    console.log('放大', scaleNum.value)
  } else {
    if (isZoomOutDisabled.value) {
      return
    }
    scaleNum.value -= 0.2
  }
}
function handlePreview () {
  if (isPrevDisabled.value) {
    return
  }
  scaleNum.value = 1
  restoreNum.value = 3
  currentIndex.value--
  currentImg.value = imgSrcList.value[currentIndex.value]
  onMediaItemChange()
}
function handleNext () {
  if (isNextDisabled.value) {
    return
  }
  scaleNum.value = 1
  restoreNum.value = 3
  currentIndex.value++
  currentImg.value = imgSrcList.value[currentIndex.value]
  onMediaItemChange()
}
function handleImgPreview (index:number) {
  currentIndex.value = index
  currentImg.value = imgSrcList.value[currentIndex.value]
  onMediaItemChange()
}

function onMediaItemChange () {
  currentImageAnnotations.value = []
  clearImageAnnotationCanvas()
  nextTick(() => {
    if (props.type === 'media' && currentImg.value && !isVideoFile(getMediaKey(currentImg.value))) {
      void loadImageAnnotations(currentImg.value)
    }
  })
}

// 根据当前语言环境获取告警标签显示
function getAlarmDisplayLabel (item: any): string {
  if (!item) return ''
  const labelLike = {
    label: item.labelCn || item.label || item.modelName,
    labelCn: item.labelCn,
    labelEn: item.labelEn,
  }
  return getAnnotationDisplayLabel(labelLike, locale.value, labelStore || undefined)
}
function isActiveItem (item: any, index: number) {
  if (currentIndex.value === index) {
    return true
  }
  if (!currentImg.value) {
    return false
  }
  const currentKey = getMediaKey(currentImg.value)
  const itemKey = getMediaKey(item)
  return !!currentKey && currentKey === itemKey
}
function getMediaKey (item: any): string {
  if (!item) {
    return ''
  }
  return getAlarmImageUrl(item) || item.object_keys || item.file_name || item.name || ''
}
/** 与 MediaPanel 卡片下载一致：在资源 URL 上附加 response-content-type */
function getMediaDownloadBase (item: any): string {
  if (!item) {
    return ''
  }
  const direct = String(item.object_key || item.object_keys || '').trim()
  if (direct) {
    return direct
  }
  return getAlarmImageUrl(item)
}
function getMediaDownloadHref (item: any): string {
  const base = getMediaDownloadBase(item)
  if (!base) {
    return ''
  }
  const sep = base.includes('?') ? '&' : '?'
  return `${base}${sep}response-content-type=application/octet-stream`
}
function getMediaDownloadFilename (item: any): string {
  if (!item) {
    return 'image.jpg'
  }
  const name = item.file_name || (item.objectKey && String(item.objectKey).split('/').pop())
  if (name) {
    return String(name).includes('.') ? String(name) : `${name}.jpg`
  }
  return `alarm-${item.id || 'image'}.jpg`
}
function isVideoFile (path: string): boolean {
  if (!path || typeof path !== 'string') {
    return false
  }
  return path.toLowerCase().indexOf('.mp4') !== -1
}
function hasMediaError (item: any): boolean {
  const key = getMediaKey(item)
  if (!key) {
    return false
  }
  return !!mediaErrorMap.value[key]
}
function onMediaError (item: any) {
  const key = getMediaKey(item)
  if (!key) {
    return
  }
  mediaErrorMap.value[key] = true
}
function onMediaLoad (item: any) {
  const key = getMediaKey(item)
  if (!key) {
    return
  }
  mediaErrorMap.value[key] = false
}
function hasValidLatLng (item: any): boolean {
  if (!item) {
    return false
  }
  const lat = Number(item.lat)
  const lng = Number(item.lng)
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return false
  }
  if (lat === 0 || lng === 0) {
    return false
  }
  return true
}
function closeImgPreview () {
  currentImg.value = ''
  currentIndex.value = 0
  imgSrcList.value = []
  scaleNum.value = 1
  restoreNum.value = 1
  currentImageAnnotations.value = []
  annotationRequestId++
  clearCanvas()
  clearImageAnnotationCanvas()
  cocoFramesCache.value = null
  if (animationFrameId !== null) {
    cancelAnimationFrame(animationFrameId)
    animationFrameId = null
  }
  emit('onClose', false)
  emit('on-close', false)
}

// 视频相关函数
function handleVideoLoaded () {
  if (!videoElement.value || !canvasElement.value) return
  
  updateCanvasSize()
}

function updateCanvasSize () {
  if (!videoElement.value || !canvasElement.value) return
  
  const video = videoElement.value
  const canvas = canvasElement.value
  
  // 设置 canvas 尺寸与视频显示尺寸一致
  const rect = video.getBoundingClientRect()
  canvas.width = rect.width
  canvas.height = rect.height
  
  // 重新绘制当前帧的标注
  if (video.currentTime !== undefined) {
    handleVideoTimeUpdate()
  } else {
    clearCanvas()
  }
}

function handleVideoTimeUpdate () {
  if (!videoElement.value || !canvasElement.value || !currentImg.value) return
  
  const video = videoElement.value
  const canvas = canvasElement.value
  const currentTime = video.currentTime // 当前播放时间（秒）
  
  // 确保 canvas 尺寸与视频显示尺寸一致（处理窗口大小变化）
  const rect = video.getBoundingClientRect()
  if (canvas.width !== rect.width || canvas.height !== rect.height) {
    canvas.width = rect.width
    canvas.height = rect.height
  }
  
  // 获取 processedCocoData
  const processedCocoData = currentImg.value.processedCocoData
  if (!processedCocoData || !Array.isArray(processedCocoData)) {
    clearCanvas()
    return
  }

  // 第一次使用时，把 COCO 结果按 image_id 分组，缓存在内存中
  if (!cocoFramesCache.value) {
    const frameMap = new Map<number, any>()

    processedCocoData.forEach((item: any) => {
      if (!item.image || item.image.id === undefined) return
      const imageId = item.image.id as number
      let frame = frameMap.get(imageId)
      if (!frame) {
        frame = {
          image_id: imageId,
          timestamp: item.image.timestamp,
          width: item.image.width,
          height: item.image.height,
          items: [] as any[]
        }
        frameMap.set(imageId, frame)
      }
      frame.items.push(item)
    })

    // 转成按时间排序的数组，方便后面查找“最近的一帧”
    cocoFramesCache.value = Array.from(frameMap.values()).sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0))
  }

  const frames = cocoFramesCache.value || []
  if (!frames.length) {
    clearCanvas()
    return
  }

  // 找到 timestamp 与 currentTime 差值最小的那一帧
  let closestFrame: any = null
  let minDiff = Infinity
  frames.forEach(frame => {
    if (frame.timestamp === undefined) return
    const diff = Math.abs(frame.timestamp - currentTime)
    if (diff < minDiff) {
      minDiff = diff
      closestFrame = frame
    }
  })

  // 如果最近的一帧也太远（例如超过 0.5 秒），认为当前时间没有有效标注
  if (!closestFrame || minDiff > 0.5) {
    clearCanvas()
    return
  }

  // 可选：限制同一帧最多显示的框数量（按置信度从高到低）
  let items: any[] = closestFrame.items || []
  items = items
    .slice()
    .sort((a, b) => (b.annotation?.confidence || 0) - (a.annotation?.confidence || 0))
    .slice(0, 20) // 每帧最多显示 20 个框，可按需要调整

  // 实时打印这一帧的关键信息
  console.log('=== 当前视频时间:', currentTime.toFixed(3), '秒; 使用帧时间戳:', closestFrame.timestamp?.toFixed(3), '秒 ===')
  items.forEach((item: any, index: number) => {
    console.log(`标注框 ${index + 1}:`, {
      bbox: item.annotation?.bbox, // [x, y, w, h]
      category_id: item.annotation?.category_id,
      image_id: item.annotation?.image_id,
      name: item.category?.name,
      height: item.image?.height,
      timestamp: item.image?.timestamp,
      width: item.image?.width,
      confidence: item.annotation?.confidence
    })
  })
  console.log('==========================================\n')

  drawBoundingBoxes(items)
}

function drawBoundingBoxes (annotations: any[]) {
  if (!videoElement.value || !canvasElement.value) return
  
  const video = videoElement.value
  const canvas = canvasElement.value
  const ctx = canvas.getContext('2d')
  if (!ctx) return
  
  // 清除之前的绘制
  clearCanvas()
  
  if (annotations.length === 0) return
  
  // 获取容器尺寸
  const rect = video.getBoundingClientRect()
  const videoWidth = video.videoWidth
  const videoHeight = video.videoHeight
  const containerWidth = rect.width
  const containerHeight = rect.height

  // 容器与视频本身的宽高比
  const videoAspect = videoWidth / videoHeight
  const containerAspect = containerWidth / containerHeight

  // 计算包含（object-fit: contain）时，视频在容器中的真实显示区域
  let displayWidth: number
  let displayHeight: number
  let offsetX = 0
  let offsetY = 0

  if (containerAspect > videoAspect) {
    // 容器更扁，视频以高度为基准缩放，两侧会有左右黑边
    displayHeight = containerHeight
    displayWidth = displayHeight * videoAspect
    offsetX = (containerWidth - displayWidth) / 2
    offsetY = 0
  } else {
    // 容器更窄，视频以宽度为基准缩放，上下会有黑边
    displayWidth = containerWidth
    displayHeight = displayWidth / videoAspect
    offsetX = 0
    offsetY = (containerHeight - displayHeight) / 2
  }

  // 计算缩放比例（原始视频坐标 -> 实际显示区域）
  const scaleX = displayWidth / videoWidth
  const scaleY = displayHeight / videoHeight
  
  // 绘制每个 bbox
  annotations.forEach((item: any, index: number) => {
    if (!item.annotation || !item.annotation.bbox || !item.image) return
    
    const bbox = item.annotation.bbox // [x, y, width, height]
    const [x, y, width, height] = bbox
    
    // 将 bbox 坐标转换为显示坐标（加上黑边偏移）
    const displayX = offsetX + x * scaleX
    const displayY = offsetY + y * scaleY
    const displayWidth_scaled = width * scaleX
    const displayHeight_scaled = height * scaleY
    
    
    // 绘制蓝色矩形框
    ctx.strokeStyle = '#1890ff' // 蓝色
    ctx.lineWidth = 2
    ctx.strokeRect(displayX, displayY, displayWidth_scaled, displayHeight_scaled)
    
    // 可选：绘制类别名称
    if (item.category && item.category.name) {
      const categoryName = item.category.name
      // 尝试通过标签库进行国际化
      const labelOption = labelStore.findByEn(categoryName)
      const displayLabel = labelOption?.labelCn || categoryName

      ctx.fillStyle = '#1890ff'
      ctx.font = '14px Arial'
      ctx.fillText(displayLabel, displayX, displayY - 5)
    }
  })
}

function clearCanvas () {
  if (!canvasElement.value) return
  const ctx = canvasElement.value.getContext('2d')
  if (ctx) {
    ctx.clearRect(0, 0, canvasElement.value.width, canvasElement.value.height)
  }
}

onUnmounted(() => {
  if (animationFrameId !== null) {
    cancelAnimationFrame(animationFrameId)
    animationFrameId = null
  }
  window.removeEventListener('resize', onPreviewResize)
  clearCanvas()
  clearImageAnnotationCanvas()
})

</script>
<style lang="scss" scoped>

.map-box{
  width: 100%;
  height: 200px;
}
.location-empty{
  width: 100%;
  height: 200px;
  border: 1px dashed rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img-panel-wrapper{
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: fixed;
    left: 0;
    top: 0;
    background-color: $bg-base;
    z-index: 9999;
}
.img-info-box{
  width: 100%;
  height: calc(100% - 180px);
}
.img-list-box{
  width: 100vw;
  height: 180px;
  border-top: 1px solid $border-default;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
}
.tool-box{
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
}
.list-scroll-box{
  width: 70%;
  height: 100%;
  overflow: hidden;
  overflow-x: auto;
  padding-bottom: 10px
}
.preview-box{
  width: 80%;
  height: 100%;
  background-color: $bg-overlay;
  position: relative;
  overflow: hidden;
}
.image-preview-stage {
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-preview-media {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-origin: center center;
}
.image-preview-frame {
  position: relative;
  display: inline-block;
  height: 100%;
  line-height: 0;
}
.image-preview-frame img {
  display: block;
  height: 100%;
  width: auto;
}
.image-annotation-canvas {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.video-wrapper{
  width: 100%;
  height: 100%;
  position: relative;
}
.video-canvas{
  width: 100%;
  height: 100%;
}
.img-preview-info-box{
  width: 20%;
  height: 100%;
  position: relative;
  padding: 20px 30px;
  box-sizing: border-box;
}
.preview-btn{
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
}
.next-btn{
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
}
.viewer-list{
  width: 96px;
  height: 54px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-sizing: border-box;
  -webkit-filter: brightness(60%); /* Chrome, Safari, Opera */
  filter:brightness(60%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink:0;
}
.thumb-load-error{
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.65);
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.thumb-media{
  width: 100%;
  height: 100%;
  border-radius: inherit;
  object-fit: cover;
  display: flex;
  cursor:pointer;
}
.media-load-error{
  width: 100%;
  height: 100%;
  color: rgba(255, 255, 255, 0.75);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.is-active-img{
  border: 2px solid #1088f2;
  border-radius: $border-radius-md;
  -webkit-filter: brightness(100%); /* Chrome, Safari, Opera */
  filter:brightness(100%)
}
.close-btn{
  position: absolute;
  right: 20px;
  top: 30px;
}
.ui-icon-action {
  color: var(--uav-icon-action-default);
  transition: color 0.2s ease;
  cursor: pointer;
}
.ui-icon-action:hover,
.ui-icon-action:focus-visible {
  color: var(--uav-icon-action-hover);
}
.ui-icon-action:active {
  color: var(--uav-icon-action-active);
}
.ui-icon-action.is-disabled {
  color: var(--uav-icon-action-disabled);
  pointer-events: none;
  cursor: not-allowed;
}
.nav-icon {
  font-size: 48px;
}
.tool-icon {
  font-size: 24px;
}
</style>
